module.exports = __webpack_public_path__ + "static/media/5061.28c9c9a3.jpg";